export const PROJECTS = [
  {
    name: "Ambientify",
    image: "ambientify",
    description: 'Born as a personal project of mine, this app provides users a nice interface for mixing ambient sounds / white noises.<br/>It offers the ability to add custom sounds and presets, a timer, shuffle and "pitch randomizer".<br/>I chose redux as state container. I then took advantage of redux-persist to more easily persist state via AsyncStorage. i18next was then used for localization.',
    tags: "#ReactNative #StyledComponents #Redux #node.js #expo-unimodules #google-iap #i18next",
    date: "10/01/2020",
    link: "https://play.google.com/store/apps/details?id=com.dominickv.ambientify"
  },
  {
    name: "Photographer E‑commerce",
    image: "photographer_e_commerce",
    description: "A minimalistic e-commerce for a John Doe photographer trying to sell some of his shots. Server-side rendered with Next.js, it features contentful as headless-cms. Context API was used for state management. Also, i wanted to try out stripe, so i used express for a simple and quick custom back-end...",
    tags: "#React #StyledComponents #contentful #node.js #express #next #stripe #framer-motion",
    date: "02/13/2020",
    link: "https://photographer-e-commerce.herokuapp.com"
  },
];


export const DESIGNS = [
  {
    name: "Ambientify",
    image: "ambientify",
    link: "https://www.figma.com/file/88w0ZChlFb3L15wVPDdcXl/Ambientify"
  },
  {
    name: "Photographer e-commerce",
    image: "photographer_e_commerce",
    link: "https://www.figma.com/file/klWsXmcbR6e6SJhe1ke1R4/Photographer-e-commerce"
  },
  {
    name: "America Sporting Club",
    image: "america_sportclub",
    link: "https://www.figma.com/file/3SYyllsJUHsMPAJgkiNFwF/America-Gym"
  },
]